import {HostListener, Injectable, OnDestroy} from "@angular/core";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {TiberEnvironmentProvider} from "../environment";

@Injectable({providedIn: 'root'})
export class RouteLoggerService implements OnDestroy {
    exitListener = null;

    constructor(private router: Router, private http: HttpClient, private environment:TiberEnvironmentProvider) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const fullUrl = window.location.href;
                this.sendAuditBlip(fullUrl);
            });

        this.exitListener = this.sendExitBlip.bind(this);
        window.addEventListener('beforeunload', this.exitListener);
    }

    ngOnDestroy() {
        if (this.exitListener) {
            window.removeEventListener('beforeunload', this.exitListener);
        }
    }

    private sendAuditBlip(url: string) {
        const apiUrl = "/api/dashboard/route";
        this.http.post(apiUrl, {
            uri: url,
            spa: this.environment.spa
        })
            .subscribe({
            next: () => {},
            error: err => console.error('Audit failed', err)
        });
    }

    private sendExitBlip(event: BeforeUnloadEvent) {
        const apiUrl = "/api/dashboard/route";
        const data = {
            uri: '*** SPA Exit ***',
            spa: this.environment.spa
        };

        try {
            if (navigator.sendBeacon) {
                const headers = {
                    type: "application/json"
                };
                const blob = new Blob([JSON.stringify(data)], headers);
                navigator.sendBeacon(apiUrl, blob);
            } else {
                const xhr = new XMLHttpRequest();
                xhr.open("POST", apiUrl, false);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(JSON.stringify(data));
            }
        } catch (error) {
            console.error('Exit blip failed:', error);
        }
    }
}